/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: m89ZcmmDcMEs

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicNotice.module.css"; // plasmic-import: m89ZcmmDcMEs/css

import Icon77Icon from "./icons/PlasmicIcon__Icon77"; // plasmic-import: QvtSJ68Zs7Tc/icon
import WarningXSmallIcon from "./icons/PlasmicIcon__WarningXSmall"; // plasmic-import: MGFcvmbudZJ7/icon

createPlasmicElementProxy;

export type PlasmicNotice__VariantMembers = {
  noCornerRadius: "noCornerRadius";
  status: "error" | "warning" | "brightInfo" | "darkInfo";
  stretch: "stretch";
};
export type PlasmicNotice__VariantsArgs = {
  noCornerRadius?: SingleBooleanChoiceArg<"noCornerRadius">;
  status?: SingleChoiceArg<"error" | "warning" | "brightInfo" | "darkInfo">;
  stretch?: SingleBooleanChoiceArg<"stretch">;
};
type VariantPropType = keyof PlasmicNotice__VariantsArgs;
export const PlasmicNotice__VariantProps = new Array<VariantPropType>(
  "noCornerRadius",
  "status",
  "stretch"
);

export type PlasmicNotice__ArgsType = { message?: string };
type ArgPropType = keyof PlasmicNotice__ArgsType;
export const PlasmicNotice__ArgProps = new Array<ArgPropType>("message");

export type PlasmicNotice__OverridesType = {
  alert?: Flex__<"div">;
  noticeWrapper?: Flex__<"div">;
  iconWrapper?: Flex__<"div">;
  icon?: Flex__<"svg">;
  text?: Flex__<"div">;
};

export interface DefaultNoticeProps {
  message?: string;
  noCornerRadius?: SingleBooleanChoiceArg<"noCornerRadius">;
  status?: SingleChoiceArg<"error" | "warning" | "brightInfo" | "darkInfo">;
  stretch?: SingleBooleanChoiceArg<"stretch">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicNotice__RenderFunc(props: {
  variants: PlasmicNotice__VariantsArgs;
  args: PlasmicNotice__ArgsType;
  overrides: PlasmicNotice__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          message: "Please hold on while we log you in using the email link."
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "noCornerRadius",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.noCornerRadius
      },
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.status
      },
      {
        path: "stretch",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.stretch
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"alert"}
      data-plasmic-override={overrides.alert}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.alert,
        {
          [sty.alertnoCornerRadius]: hasVariant(
            $state,
            "noCornerRadius",
            "noCornerRadius"
          ),
          [sty.alertstatus_brightInfo]: hasVariant(
            $state,
            "status",
            "brightInfo"
          ),
          [sty.alertstatus_darkInfo]: hasVariant($state, "status", "darkInfo"),
          [sty.alertstatus_error]: hasVariant($state, "status", "error"),
          [sty.alertstatus_warning]: hasVariant($state, "status", "warning"),
          [sty.alertstretch]: hasVariant($state, "stretch", "stretch")
        }
      )}
    >
      <div
        data-plasmic-name={"noticeWrapper"}
        data-plasmic-override={overrides.noticeWrapper}
        className={classNames(projectcss.all, sty.noticeWrapper, {
          [sty.noticeWrappernoCornerRadius]: hasVariant(
            $state,
            "noCornerRadius",
            "noCornerRadius"
          ),
          [sty.noticeWrapperstatus_darkInfo]: hasVariant(
            $state,
            "status",
            "darkInfo"
          ),
          [sty.noticeWrapperstatus_error]: hasVariant(
            $state,
            "status",
            "error"
          ),
          [sty.noticeWrapperstatus_warning]: hasVariant(
            $state,
            "status",
            "warning"
          ),
          [sty.noticeWrapperstretch]: hasVariant($state, "stretch", "stretch")
        })}
      >
        <div
          data-plasmic-name={"iconWrapper"}
          data-plasmic-override={overrides.iconWrapper}
          className={classNames(projectcss.all, sty.iconWrapper, {
            [sty.iconWrapperstretch]: hasVariant($state, "stretch", "stretch")
          })}
        >
          <PlasmicIcon__
            data-plasmic-name={"icon"}
            data-plasmic-override={overrides.icon}
            PlasmicIconType={
              hasVariant($state, "status", "warning")
                ? WarningXSmallIcon
                : Icon77Icon
            }
            className={classNames(projectcss.all, sty.icon, {
              [sty.iconstatus_darkInfo]: hasVariant(
                $state,
                "status",
                "darkInfo"
              ),
              [sty.iconstatus_error]: hasVariant($state, "status", "error"),
              [sty.iconstatus_warning]: hasVariant($state, "status", "warning")
            })}
            role={"img"}
          />
        </div>
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text,
            {
              [sty.textstatus_darkInfo]: hasVariant(
                $state,
                "status",
                "darkInfo"
              ),
              [sty.textstatus_error]: hasVariant($state, "status", "error"),
              [sty.textstatus_warning]: hasVariant($state, "status", "warning"),
              [sty.textstretch]: hasVariant($state, "stretch", "stretch")
            }
          )}
        >
          <div
            className={projectcss.__wab_expr_html_text}
            dangerouslySetInnerHTML={{ __html: $props.message }}
          />
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  alert: ["alert", "noticeWrapper", "iconWrapper", "icon", "text"],
  noticeWrapper: ["noticeWrapper", "iconWrapper", "icon", "text"],
  iconWrapper: ["iconWrapper", "icon"],
  icon: ["icon"],
  text: ["text"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  alert: "div";
  noticeWrapper: "div";
  iconWrapper: "div";
  icon: "svg";
  text: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNotice__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNotice__VariantsArgs;
    args?: PlasmicNotice__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicNotice__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicNotice__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNotice__ArgProps,
          internalVariantPropNames: PlasmicNotice__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNotice__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "alert") {
    func.displayName = "PlasmicNotice";
  } else {
    func.displayName = `PlasmicNotice.${nodeName}`;
  }
  return func;
}

export const PlasmicNotice = Object.assign(
  // Top-level PlasmicNotice renders the root element
  makeNodeComponent("alert"),
  {
    // Helper components rendering sub-elements
    noticeWrapper: makeNodeComponent("noticeWrapper"),
    iconWrapper: makeNodeComponent("iconWrapper"),
    icon: makeNodeComponent("icon"),
    text: makeNodeComponent("text"),

    // Metadata about props expected for PlasmicNotice
    internalVariantProps: PlasmicNotice__VariantProps,
    internalArgProps: PlasmicNotice__ArgProps
  }
);

export default PlasmicNotice;
/* prettier-ignore-end */
